<template>
    <div ref="doughnutChart" style="display: flex;width: 100%; height: 90%;align-items: center;justify-content: center;"></div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import { defineComponent, onMounted, ref } from 'vue';
  
  export default defineComponent({
    name: 'DoughnutChart',
    setup() {
      const doughnutChart = ref(null);
  
      onMounted(() => {
        const chart = echarts.init(doughnutChart.value);
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'horizontal', // 设置图例布局方式为水平
            left: 'center', // 设置图例水平居中
            bottom: '0', // 设置图例显示在底部
            data: ['作业', '授课', '资源', '讨论']
          },
          series: [
            {
              name: '平台实时动态',
              type: 'pie',
              radius: ['40%', '55%'], // 外圆环半径
              center: ['50%', '50%'],
              label: {
                show: true,
                position: 'outside',
                formatter: '{b}\n{d}%'
              },
              data: [
                { value: 335, name: '作业', itemStyle: { color: '#249eff' } },
                { value: 310, name: '授课', itemStyle: { color: '#6399ca' } },
                { value: 234, name: '资源', itemStyle: { color: '#21ccff' } },
                { value: 135, name: '讨论', itemStyle: { color: '#313ca9' } }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        };
        chart.setOption(option);
      });
  
      return {
        doughnutChart
      };
    }
  });
  </script>